export const ADMIN_DATA_REQUEST = "ADMIN_DATA_REQUEST";
export const ADMIN_DATA_SUCCESS = "ADMIN_DATA_SUCCESS";
export const ADMIN_DATA_FAIL = "ADMIN_DATA_FAIL";
